module.exports = __webpack_public_path__ + "media/images/emoticons/soccer-0c037cee8fd63d8480a4198542259eac.gif";